import {default as math} from './math';
import {default as random} from './random';

export default { math, random };
